import { render, staticRenderFns } from "./iconSparesPart.vue?vue&type=template&id=54f418eb"
import script from "./iconSparesPart.vue?vue&type=script&lang=js"
export * from "./iconSparesPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports